import {Link} from "react-router-dom";

export default function MainBlockContacts(props) {
    return (
        <section className="main_block main_block_contact">
            <div className="container">
                <div className="bread_crumbs">
                    <div>
                        <Link to="/">Главная</Link>
                    </div>
                    <div>></div>
                    <div>Контакты</div>
                </div>
                <h1>
                    <span className="title main_title">Контакты</span>
                </h1>
            </div>
        </section>
    )
}
